import {
  CheckSignSmsRequest,
  CheckSignSmsResponse,
  SendSmsRequest,
  SendSmsResponse,
  SignupStepResponse,
  StepOnePostRequest,
  StepThreePostRequest,
  StepTwoPostRequest,
} from "./types";
import { HEADERS_JSON } from "@/common/api/config";
import { CommonResponse } from "@/common/api/types";
import { catchError } from "@/common/api/utils";
import { GATEWAY_URL } from "@/common/config";

export const getSignupStep = async (
  token: string,
): Promise<SignupStepResponse> => {
  const response = await fetch(
    `${GATEWAY_URL}/application/step?token=${token}`,
    {
      method: "GET",
      headers: HEADERS_JSON,
    },
  );

  if (!response.ok) {
    localStorage.clear();
  }

  catchError(response);
  return await response.json();
};
export const postStepOneData = async (
  data: StepOnePostRequest,
): Promise<CommonResponse> => {
  const response = await fetch(`${GATEWAY_URL}/application/step1`, {
    method: "POST",
    body: JSON.stringify(data),
    headers: HEADERS_JSON,
  });
  catchError(response);
  return await response.json();
};

export const postStepTwoData = async (
  data: StepTwoPostRequest,
): Promise<CommonResponse> => {
  const response = await fetch(`${GATEWAY_URL}/application/step2`, {
    method: "POST",
    body: JSON.stringify(data),
    headers: HEADERS_JSON,
  });
  catchError(response);
  return await response.json();
};

export const postStepThreeData = async (
  data: StepThreePostRequest,
): Promise<CommonResponse> => {
  const response = await fetch(`${GATEWAY_URL}/application/step3`, {
    method: "POST",
    body: JSON.stringify(data),
    headers: HEADERS_JSON,
  });
  catchError(response);
  return await response.json();
};

export const postSmsSend = async ({
  phone,
  iin,
}: SendSmsRequest): Promise<SendSmsResponse> => {
  const response = await fetch(`${GATEWAY_URL}/auth/sms-send`, {
    method: "POST",
    body: JSON.stringify({ phone, iin }),
    headers: HEADERS_JSON,
  });
  catchError(response);
  return await response.json();
};

export const postSmsCheck = async (
  data: CheckSignSmsRequest,
): Promise<CheckSignSmsResponse> => {
  const response = await fetch(`${GATEWAY_URL}/auth/register/sms-check`, {
    method: "POST",
    headers: HEADERS_JSON,
    body: JSON.stringify(data),
  });
  catchError(response);
  return await response.json();
};
